import { gql } from "@apollo/client";

export default gql`
  mutation MarkProgramAsComplete($cpeId: Float!) {
    markProgramAsComplete(cpeId: $cpeId)
  }
`;
